module.exports = __webpack_public_path__ + "img/block-green.0f5aea94.png";